import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "@/components/rotta/Navbar";
import Footer from "@/components/rotta/Footer";
import ScrollToTop from "@/components/rotta/ScrollToTop";
import SmoothScroll from "@/components/rotta/SmoothScroll";
import Home from "@/pages/Home";
import Rotas from "@/pages/Rotas";
import RotaDetail from "@/pages/RotaDetail";
import Cidades from "@/pages/Cidades";
import CidadeDetail from "@/pages/CidadeDetail";
import Eventos from "@/pages/Eventos";
import EventoDetail from "@/pages/EventoDetail";
import Blog from "@/pages/Blog";
import BlogDetail from "@/pages/BlogDetail";
import Sobre from "@/pages/Sobre";
import Parcerias from "@/pages/Parcerias";

// Admin
import { AdminAuthProvider } from "@/admin/AdminAuthContext";
import AdminProtected from "@/admin/AdminProtected";
import AdminLayout from "@/admin/AdminLayout";
import AdminLogin from "@/admin/pages/AdminLogin";
import AdminDashboard from "@/admin/pages/AdminDashboard";
import RouteList from "@/admin/pages/RouteList";
import RouteForm from "@/admin/pages/RouteForm";
import CityList from "@/admin/pages/CityList";
import CityForm from "@/admin/pages/CityForm";
import EventList from "@/admin/pages/EventList";
import EventForm from "@/admin/pages/EventForm";
import BlogList from "@/admin/pages/BlogList";
import BlogForm from "@/admin/pages/BlogForm";
import Subscribers from "@/admin/pages/Subscribers";
import RouteSuggestions from "@/admin/pages/RouteSuggestions";

function PublicSite() {
  return (
    <SmoothScroll>
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/rotas" element={<Rotas />} />
          <Route path="/rotas/:slug" element={<RotaDetail />} />
          <Route path="/cidades" element={<Cidades />} />
          <Route path="/cidades/:slug" element={<CidadeDetail />} />
          <Route path="/eventos" element={<Eventos />} />
          <Route path="/eventos/:slug" element={<EventoDetail />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogDetail />} />
          <Route path="/sobre" element={<Sobre />} />
          <Route path="/parcerias" element={<Parcerias />} />
        </Routes>
      </main>
      <Footer />
    </SmoothScroll>
  );
}

function App() {
  return (
    <div className="App min-h-screen bg-[#0B0B0B]">
      <BrowserRouter>
        <ScrollToTop />
        <AdminAuthProvider>
          <Routes>
            {/* Admin */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route element={<AdminProtected />}>
              <Route element={<AdminLayout />}>
                <Route path="/admin" element={<AdminDashboard />} />
                <Route path="/admin/rotas" element={<RouteList />} />
                <Route path="/admin/rotas/nova" element={<RouteForm />} />
                <Route path="/admin/rotas/:id" element={<RouteForm />} />
                <Route path="/admin/cidades" element={<CityList />} />
                <Route path="/admin/cidades/nova" element={<CityForm />} />
                <Route path="/admin/cidades/:id" element={<CityForm />} />
                <Route path="/admin/eventos" element={<EventList />} />
                <Route path="/admin/eventos/novo" element={<EventForm />} />
                <Route path="/admin/eventos/:id" element={<EventForm />} />
                <Route path="/admin/blog" element={<BlogList />} />
                <Route path="/admin/blog/novo" element={<BlogForm />} />
                <Route path="/admin/blog/:id" element={<BlogForm />} />
                <Route path="/admin/inscritos" element={<Subscribers />} />
                <Route path="/admin/sugestoes" element={<RouteSuggestions />} />
              </Route>
            </Route>

            {/* Public marketing site */}
            <Route path="/*" element={<PublicSite />} />
          </Routes>
        </AdminAuthProvider>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: { background: "#1A1A1A", border: "1px solid #2a2a2a", color: "#F2F2F2" },
        }}
      />
    </div>
  );
}

export default App;
